// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"884612d6","455":"7c075cff","977":"d9cf2bb4"}[chunkId] + ".chunk.js";
};